import { makeAutoObservable } from 'mobx'
import { type IAvatarInfo } from 'shared/ui'
import { type IResponseAnalyticContact } from './type'

export class AnalyticContact {
  id: number
  first_name: string
  last_name: string
  full_name: string
  photo_url?: string
  email: string | null
  number: string
  item: IResponseAnalyticContact

  constructor(item: IResponseAnalyticContact) {
    this.id = item.id
    this.first_name = item.first_name
    this.last_name = item.last_name
    this.full_name = item.full_name
    this.email = item.email
    this.number = item.number
    this.item = item

    this.photo_url = item.photo_url || ''

    makeAutoObservable(this)
  }

  get fullName() {
    let output = ''
    const first_name = this.first_name
    const last_name = this.last_name
    const full_name = this.full_name

    if (first_name) {
      output = first_name

      if (last_name) {
        output += ' ' + last_name
      }
    } else if (full_name) {
      output = full_name
    }

    return output
  }

  get name() {
    let output = ''
    const full_name = this.fullName.trim()

    if (full_name) {
      output = full_name
    } else if (this.email) {
      output = this.email
    } else if (this.number) {
      output = this.number
    }

    return output ? output : ''
  }

  get avatarInfo(): IAvatarInfo {
    const isPhoneAbbr = !this.first_name && !this.last_name

    return {
      isPhoneAbbr,
      firstName: this.first_name,
      lastName: this.last_name,
      image: this.photo_url || '',
      color: this.generateColor,
      number: this.number,
    }
  }

  get generateColor() {
    const colors = ['#6372A5', '#1D95F2', '#10D0AD', '#E13466', '#FFC422', '#FF9423', '#A233E1']

    return colors[this.id % colors.length]
  }
}
